import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'default' | 'small';
}

export default function ComicCard({ comic, size = 'default' }: ComicCardProps) {
  const isSmall = size === 'small';

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg mb-3 ${isSmall ? 'aspect-[3/4]' : 'aspect-[3/4]'}`}>
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 韩漫网免费在线漫画`}
          title={`${comic.title} - 韩漫网免费在线漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className={`absolute top-2 left-2 ${comic.status === '已完结' ? 'bg-secondary-500' : 'bg-primary-500'} text-white text-xs px-2 py-0.5 rounded-full whitespace-nowrap`}>
          {comic.status}
        </div>
        <div className="absolute bottom-2 left-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="text-white text-xs bg-black/40 px-2 py-1 rounded-full whitespace-nowrap">
            共 {comic.chapters} 话
          </span>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
      {!isSmall && (
        <div className="flex items-center gap-2 mt-1.5">
          <span className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-star-fill text-xs text-accent-500"></i>
          </span>
          <span className="text-xs text-accent-600 font-medium">{comic.rating}</span>
          <span className="text-xs text-foreground-400">{comic.views}</span>
        </div>
      )}
    </Link>
  );
}